import type { CarrierCargoListPageProps } from "@/pages/carrier-cargo-list/model";
import type { CarrierCargoTableData } from "@/pages/carrier-cargo-list/ui/CargoTable";
import { mapDraftOfferCargoToCarrierCargoTableData } from "@/pages/carrier-cargo-list/ui/CargoTable/utils";
import { MobileCargoListItem } from "@/pages/carrier-cargo-list/ui/mobile/cargo-list/cargo-list-item";
import type { LoadableData } from "@/shared/lib/loadable";
import { Box, Stack } from "@mui/material";
import { useMemo } from "react";

type Props = {
  user: LoadableData<CarrierCargoListPageProps["user"]>;
  draftOfferCargos: LoadableData<CarrierCargoListPageProps["draftOfferCargos"]>;
};

export const MobileCargoList: React.FC<Props> = ({
  user,
  draftOfferCargos,
}) => {
  const data = useMemo(
    () =>
      draftOfferCargos.data
        .map<CarrierCargoTableData>((offerCargo) =>
          mapDraftOfferCargoToCarrierCargoTableData(offerCargo, user),
        )
        .sort((a, b) => {
          return b.id - a.id;
        }),
    [draftOfferCargos.data, user],
  );

  return (
    <Stack
      direction="column"
      gap={1}
      px={1}
      py={2}
      sx={{
        backgroundColor: "grey.50",
        border: "1px solid #E4E5E5",
        borderWidth: "1px 0",
      }}
    >
      {data.map((cargo) => (
        <Box
          key={cargo.id}
          sx={{
            backgrounColor: "white",
            boxShadow: "0px 1px 10px 0px #0000001A",
            borderRadius: "18px",
            border: "1px solid #E4E5E5",
            p: 1.5,
          }}
        >
          <MobileCargoListItem key={cargo.id} cargo={cargo} />
        </Box>
      ))}
    </Stack>
  );
};
